import type {
  ProcessInfo,
  ProcessInfoName,
  ProcessStep,
  ProcessStepName,
} from "../types/types";

const getProcessInfo = (
  processStepName: ProcessStepName,
  name: ProcessInfoName = "webshop",
  subStep?: number,
): ProcessInfo => {
  const processStep: ProcessStep = {
    mainStep: processStepName,
    subStep: subStep,
    status: undefined,
  };

  return {
    name: name,
    processStep: processStep,
    part: undefined,
  };
};

export default {
  getProcessInfo,
};
